import React from 'react';
import { InfoWrapper, NameCard, NameCardWrapper } from './styles';
import { COLORS, toRGBA } from '@cuemath/comps';
import { POCValue } from 'screens/student-details/styled-comps';

const getAssignTeacherData = data => {
  const {
    student_name: studentName,
    teacher_name: teacherName,
    grade,
    region,
    class_balance: classBalance,
    tenure_end_date: tenureEndDate,
    regular_slots: regularSlots,
  } = data || {};

  return [
    {
      title: 'Student',
      value: studentName,
    },
    {
      title: 'Teacher',
      value: teacherName,
    },
    {
      title: 'Grade',
      value: grade,
    },
    {
      title: 'Region',
      value: region,
    },
    {
      title: 'Class Balance',
      value: classBalance,
    },
    {
      title: 'Tenure end date',
      value: tenureEndDate,
    },
    {
      title: 'Regular slots',
      value: regularSlots,
    },
  ];
};

const AssignTeacher = ({ data }) => {
  const assignTeacherData = getAssignTeacherData(data);

  return (
    <InfoWrapper border>
      {assignTeacherData.map(item => {
        const { title, value } = item || {};

        return (
          <NameCardWrapper key={title} alignItems="center" flexDirection="row" nowrap>
            <NameCard variant="eyebrow2" color={toRGBA(COLORS.COLA, 0.75)}>
              {title}
            </NameCard>
            <POCValue variant="cta1">{value || '-'}</POCValue>
          </NameCardWrapper>
        );
      })}
    </InfoWrapper>
  );
};

export default AssignTeacher;
